import { AccountCircle, Logout, Settings, Support, Swap } from "@dippi/icons";
import { getRoutes } from "@/utils/helpers";
import storage from "@/utils/storage";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import { IconButton, ListItemIcon, MenuItem, Typography } from "@mui/material";
import { Theme } from "@mui/system";
import React from "react";
import { useHeader } from "./hooks";
import { Styled } from "./styles";
import constant from "@/utils/constant";

const HeaderTop: React.FC = () => {
    const { anchorEl, onOpenMenu, onCloseMenu, onLogout, onSwitch, onMenu, onLogo } = useHeader();

    const isMenuActive = anchorEl !== null && {
        borderColor: (theme: Theme) => theme.palette.primary.main,
        "& .MuiIconButton-root": {
            color: (theme: Theme) => theme.palette.primary.main,
        },
    };

    const routes = getRoutes();

    const oid = storage.getItem("oid");
    const hasMultipleOrgs = storage.getItem("hasMultipleOrgs");

    const { dippiLogo, defaultAvatar } = constant.ASSETS;

    return (
        <Styled.Container>
            <Styled.Logo
                src={dippiLogo}
                alt="Dippi logo"
                data-testid="dippi-logo"
                onClick={onLogo}
            />

            <Styled.Dropdown sx={{ ...isMenuActive }}>
                <IconButton data-testid="app-menu-button" onClick={onOpenMenu} disableRipple={true}>
                    <img src={defaultAvatar} height={32} width={32} />
                    <ArrowDropDownIcon />
                </IconButton>
                <Styled.Menu
                    sx={{ mt: "35px" }}
                    anchorEl={anchorEl}
                    anchorOrigin={{
                        vertical: "top",
                        horizontal: "right",
                    }}
                    transformOrigin={{
                        vertical: "top",
                        horizontal: "right",
                    }}
                    open={Boolean(anchorEl)}
                    onClose={onCloseMenu}
                    onClick={onCloseMenu}
                    data-testid="app-menu"
                >
                    <MenuItem
                        data-testid="menu-profile"
                        onClick={onMenu.bind(this, routes.profile)}
                    >
                        <Styled.ItemContent textAlign="center">
                            <ListItemIcon>
                                <AccountCircle />
                            </ListItemIcon>
                            <Typography>Profile</Typography>
                        </Styled.ItemContent>
                    </MenuItem>
                    {oid ? (
                        <MenuItem
                            data-testid="menu-settings"
                            onClick={onMenu.bind(this, routes.organizationSettings())}
                        >
                            <Styled.ItemContent textAlign="center">
                                <ListItemIcon>
                                    <Settings />
                                </ListItemIcon>
                                <Typography>Settings</Typography>
                            </Styled.ItemContent>
                        </MenuItem>
                    ) : null}
                    {oid && hasMultipleOrgs ? (
                        <MenuItem data-testid="menu-switch" onClick={onSwitch}>
                            <Styled.ItemContent textAlign="center">
                                <ListItemIcon>
                                    <Swap />
                                </ListItemIcon>
                                <Typography>Switch</Typography>
                            </Styled.ItemContent>
                        </MenuItem>
                    ) : null}
                    <MenuItem
                        data-testid="menu-support"
                        onClick={onMenu.bind(this, routes.support)}
                    >
                        <Styled.ItemContent textAlign="center">
                            <ListItemIcon>
                                <Support />
                            </ListItemIcon>
                            <Typography>Support</Typography>
                        </Styled.ItemContent>
                    </MenuItem>
                    <MenuItem data-testid="menu-logout" onClick={onLogout}>
                        <Styled.ItemContent textAlign="center">
                            <ListItemIcon>
                                <Logout />
                            </ListItemIcon>
                            <Typography>Log out</Typography>
                        </Styled.ItemContent>
                    </MenuItem>
                </Styled.Menu>
            </Styled.Dropdown>
        </Styled.Container>
    );
};

export default HeaderTop;
